import { useNavigate } from "react-router-dom";
const Wishlist = () => {
  const navigate = useNavigate();
  const onClickHandler = () => {
    navigate("/wishlist");
  };
  return (
    <div
      className="flex text-xs font-medium py-1 pl-8"
      onClick={onClickHandler}
    >
      <img className="w-3 h-4 pt-1 mr-3 " src="/images/wishlistIcon.svg" alt="" />
      Wishlist
    </div>
  );
};
export default Wishlist;